
































import { Component, Vue, Prop } from "vue-property-decorator";
import LocalizeUtil from "@/services/payment/localize";

@Component
export default class CoinFeed extends Vue {
  @Prop()
  private offer: any;

  get localizePrice() {
    return LocalizeUtil.getLocalizePriceByOffer(this.offer);
  }

  private buyCoinFeed() {
    this.$emit("buyCoinFeed");
  }
}
